/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import * as com_amazon_coral_availability from "@amzn/coral_com-amazon-coral-availability";
import * as com_amazon_coral_service_bsf from "@amzn/coral_com-amazon-coral-service-bsf";
import * as com_amazon_coral_client from "@amzn/coral_com-amazon-coral-client";
import * as com_amazon_coral_service from "@amzn/coral_com-amazon-coral-service";
import { GetPermissionRequestsInput } from "./GetPermissionRequestsInput";
import { ListAuthorizedPermissionKeysInput } from "./ListAuthorizedPermissionKeysInput";
import { BatchDeAssignUserOutput } from "./BatchDeAssignUserOutput";
import { ListEnabledExternalEntitiesForLogisticPartyOutput } from "./ListEnabledExternalEntitiesForLogisticPartyOutput";
import { ListAllPermissionsForEntityOutput } from "./ListAllPermissionsForEntityOutput";
import { DeactivateUserInput } from "./DeactivateUserInput";
import { DeAssignUserInput } from "./DeAssignUserInput";
import { BatchAssignUserOutput } from "./BatchAssignUserOutput";
import { ListEnabledExternalEntitiesForLogisticPartyInput } from "./ListEnabledExternalEntitiesForLogisticPartyInput";
import { BatchDeAssignUserInput } from "./BatchDeAssignUserInput";
import { UpdatePermissionRequestOutput } from "./UpdatePermissionRequestOutput";
import { GetAuthorizedPermissionsOutput } from "./GetAuthorizedPermissionsOutput";
import { DeleteCustomOperationInput } from "./DeleteCustomOperationInput";
import { PutPermissionRequestsOutput } from "./PutPermissionRequestsOutput";
import { ListEnabledExternalTermsForLogisticPartyOutput } from "./ListEnabledExternalTermsForLogisticPartyOutput";
import { IsUserAuthorizedOutput } from "./IsUserAuthorizedOutput";
import { BatchAssignUserInput } from "./BatchAssignUserInput";
import { IsUserAuthorizedInput } from "./IsUserAuthorizedInput";
import { EnableSubscriptionForLogisticsPartyOutput } from "./EnableSubscriptionForLogisticsPartyOutput";
import { EnableExternalTermForLogisticPartyInput } from "./EnableExternalTermForLogisticPartyInput";
import { ListEnabledExternalTermsForLogisticPartyInput } from "./ListEnabledExternalTermsForLogisticPartyInput";
import { ListAuthorizedGroupsOutput } from "./ListAuthorizedGroupsOutput";
import { DeactivateUserOutput } from "./DeactivateUserOutput";
import { ListAuthorizedUsersOutput } from "./ListAuthorizedUsersOutput";
import { PAMCoreUnrecoverableException } from "./PAMCoreUnrecoverableException";
import { GetAuditEventsOutput } from "./GetAuditEventsOutput";
import { PAMCoreRecoverableException } from "./PAMCoreRecoverableException";
import { EnableExternalEntityForLogisticPartyOutput } from "./EnableExternalEntityForLogisticPartyOutput";
import { ListAllOperationsOutput } from "./ListAllOperationsOutput";
import { AssignUserInput } from "./AssignUserInput";
import { UpdatePermissionRequestInput } from "./UpdatePermissionRequestInput";
import { EnableExternalEntityForLogisticPartyInput } from "./EnableExternalEntityForLogisticPartyInput";
import { PutPermissionRequestsInput } from "./PutPermissionRequestsInput";
import { DisableExternalTermForLogisticPartyInput } from "./DisableExternalTermForLogisticPartyInput";
import { GetAuditEventsInput } from "./GetAuditEventsInput";
import { CreateCustomOperationInput } from "./CreateCustomOperationInput";
import { ListAuthorizedUsersInput } from "./ListAuthorizedUsersInput";
import { ListAllPermissionsForEntityInput } from "./ListAllPermissionsForEntityInput";
import { DisableExternalTermForLogisticPartyOutput } from "./DisableExternalTermForLogisticPartyOutput";
import { PAMCoreInvalidRequestException } from "./PAMCoreInvalidRequestException";
import { GetPermissionRequestsOutput } from "./GetPermissionRequestsOutput";
import { EnableSubscriptionForLogisticsPartyInput } from "./EnableSubscriptionForLogisticsPartyInput";
import { ListAuthorizedPermissionKeysOutput } from "./ListAuthorizedPermissionKeysOutput";
import { CreatePAMRoleMappingInput } from "./CreatePAMRoleMappingInput";
import { ListAuthorizedGroupsInput } from "./ListAuthorizedGroupsInput";
import { GetAuthorizedPermissionsInput } from "./GetAuthorizedPermissionsInput";
import { EnableExternalTermForLogisticPartyOutput } from "./EnableExternalTermForLogisticPartyOutput";
import { ListAuthorizedOperationsInput } from "./ListAuthorizedOperationsInput";
import { ListAuthorizedOperationsOutput } from "./ListAuthorizedOperationsOutput";
import * as com_amazon_coral_service_jms from "@amzn/coral_com-amazon-coral-service-jms";
import * as com_amazon_coral_validate from "@amzn/coral_com-amazon-coral-validate";
import * as com_amazon_coral_service_http from "@amzn/coral_com-amazon-coral-service-http";
import { CoralClient, CoralResponse, } from "ihm-js-coral-client";
import { CoralClientSerdesInterceptor, InterceptingHandler, } from "ihm-js-coral-client";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
export const passportAccessManagementCoreSerdesInterceptor = new CoralClientSerdesInterceptor({
    AssignUser: {
        serializationFn: AssignUserInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    BatchAssignUser: {
        deserializationFn: BatchAssignUserOutput.fromJson,
        serializationFn: BatchAssignUserInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    BatchDeAssignUser: {
        deserializationFn: BatchDeAssignUserOutput.fromJson,
        serializationFn: BatchDeAssignUserInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    CreateCustomOperation: {
        serializationFn: CreateCustomOperationInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreUnrecoverableException,
        ],
    },
    CreatePAMRoleMapping: {
        serializationFn: CreatePAMRoleMappingInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    DeactivateUser: {
        deserializationFn: DeactivateUserOutput.fromJson,
        serializationFn: DeactivateUserInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    DeAssignUser: {
        serializationFn: DeAssignUserInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    DeleteCustomOperation: {
        serializationFn: DeleteCustomOperationInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreUnrecoverableException,
        ],
    },
    DisableExternalTermForLogisticParty: {
        deserializationFn: DisableExternalTermForLogisticPartyOutput.fromJson,
        serializationFn: DisableExternalTermForLogisticPartyInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    EnableExternalEntityForLogisticParty: {
        deserializationFn: EnableExternalEntityForLogisticPartyOutput.fromJson,
        serializationFn: EnableExternalEntityForLogisticPartyInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    EnableExternalTermForLogisticParty: {
        deserializationFn: EnableExternalTermForLogisticPartyOutput.fromJson,
        serializationFn: EnableExternalTermForLogisticPartyInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    EnableSubscriptionForLogisticsParty: {
        deserializationFn: EnableSubscriptionForLogisticsPartyOutput.fromJson,
        serializationFn: EnableSubscriptionForLogisticsPartyInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    GetAuditEvents: {
        deserializationFn: GetAuditEventsOutput.fromJson,
        serializationFn: GetAuditEventsInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    GetAuthorizedPermissions: {
        deserializationFn: GetAuthorizedPermissionsOutput.fromJson,
        serializationFn: GetAuthorizedPermissionsInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    GetPermissionRequests: {
        deserializationFn: GetPermissionRequestsOutput.fromJson,
        serializationFn: GetPermissionRequestsInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    IsUserAuthorized: {
        deserializationFn: IsUserAuthorizedOutput.fromJson,
        serializationFn: IsUserAuthorizedInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    ListAllOperations: {
        deserializationFn: ListAllOperationsOutput.fromJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    ListAllPermissionsForEntity: {
        deserializationFn: ListAllPermissionsForEntityOutput.fromJson,
        serializationFn: ListAllPermissionsForEntityInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    ListAuthorizedGroups: {
        deserializationFn: ListAuthorizedGroupsOutput.fromJson,
        serializationFn: ListAuthorizedGroupsInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    ListAuthorizedOperations: {
        deserializationFn: ListAuthorizedOperationsOutput.fromJson,
        serializationFn: ListAuthorizedOperationsInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    ListAuthorizedPermissionKeys: {
        deserializationFn: ListAuthorizedPermissionKeysOutput.fromJson,
        serializationFn: ListAuthorizedPermissionKeysInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    ListAuthorizedUsers: {
        deserializationFn: ListAuthorizedUsersOutput.fromJson,
        serializationFn: ListAuthorizedUsersInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreUnrecoverableException,
        ],
    },
    ListEnabledExternalEntitiesForLogisticParty: {
        deserializationFn: ListEnabledExternalEntitiesForLogisticPartyOutput.fromJson,
        serializationFn: ListEnabledExternalEntitiesForLogisticPartyInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    ListEnabledExternalTermsForLogisticParty: {
        deserializationFn: ListEnabledExternalTermsForLogisticPartyOutput.fromJson,
        serializationFn: ListEnabledExternalTermsForLogisticPartyInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    PutPermissionRequests: {
        deserializationFn: PutPermissionRequestsOutput.fromJson,
        serializationFn: PutPermissionRequestsInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
    UpdatePermissionRequest: {
        deserializationFn: UpdatePermissionRequestOutput.fromJson,
        serializationFn: UpdatePermissionRequestInput.toJson,
        modelledExceptions: [
            PAMCoreRecoverableException,
            PAMCoreInvalidRequestException,
            PAMCoreUnrecoverableException,
        ],
    },
}, [
    com_amazon_coral_availability.BackOffException,
    com_amazon_coral_availability.ThrottlingException,
    com_amazon_coral_client.ClientUnavailableException,
    com_amazon_coral_client.HttpConnectionTimeoutException,
    com_amazon_coral_client.HttpFailureException,
    com_amazon_coral_client.HttpTimeoutException,
    com_amazon_coral_service_bsf.InvalidCodigoMessageException,
    com_amazon_coral_service_http.HeaderMisclassificationException,
    com_amazon_coral_service_http.HttpNotFoundException,
    com_amazon_coral_service_http.InvalidAuthSchemeException,
    com_amazon_coral_service_http.InvalidAuthSchemeParameterException,
    com_amazon_coral_service_http.InvalidMessageDigestException,
    com_amazon_coral_service_http.MissingAuthSchemeParameterException,
    com_amazon_coral_service_http.MissingMessageDigestException,
    com_amazon_coral_service_http.MissingRequiredHeaderException,
    com_amazon_coral_service_jms.MessageProcessingException,
    com_amazon_coral_service_jms.MessagePublishException,
    com_amazon_coral_service.AccessDeniedException,
    com_amazon_coral_service.DelegationException,
    com_amazon_coral_service.ExpiredTokenException,
    com_amazon_coral_service.IncompleteSignatureException,
    com_amazon_coral_service.InternalFailure,
    com_amazon_coral_service.InvalidAwsQueryStringException,
    com_amazon_coral_service.InvalidParameterCombinationException,
    com_amazon_coral_service.InvalidParameterValueException,
    com_amazon_coral_service.InvalidQueryParameterException,
    com_amazon_coral_service.InvalidQueryStringException,
    com_amazon_coral_service.InvalidSignatureException,
    com_amazon_coral_service.MalformedHttpRequestException,
    com_amazon_coral_service.MissingActionException,
    com_amazon_coral_service.MissingAuthenticationTokenException,
    com_amazon_coral_service.MissingRequiredParameterException,
    com_amazon_coral_service.NotAuthorizedException,
    com_amazon_coral_service.RequestAbortedException,
    com_amazon_coral_service.RequestEntityTooLargeException,
    com_amazon_coral_service.RequestExpiredException,
    com_amazon_coral_service.RequestTimeoutException,
    com_amazon_coral_service.SerializationException,
    com_amazon_coral_service.ServiceUnavailableException,
    com_amazon_coral_service.SubscriptionRequiredException,
    com_amazon_coral_service.TimeoutException,
    com_amazon_coral_service.TransmutationException,
    com_amazon_coral_service.UnknownOperationException,
    com_amazon_coral_service.UnrecognizedClientException,
    com_amazon_coral_service.UnsupportedMediaTypeException,
    com_amazon_coral_validate.ValidationException,
]);
/**
 * Passport Access Management Core Service contains APIs to configure and access\/query user permissions.
 *
 * The APIs are of 2 types:
 * 1) Configuration: These APIs will be used to configure PAM Operations like EDIT, VIEW etc. and manage user
 * assignment and de-assignment on these operations for some defined resource (Permission Key). PAM Web
 * Server\/UI will call these APIs to perform configuration.
 * 2) Access\/Enforcement: These APIs will be used to query user access on the operations for some resource
 * (permission key) and will be used by Passport Tenant applications to enforce user access control.
 *
 * Contains all the operations and models for Passport Access Management Core Service as defined in the wiki
 * https:\/\/w.amazon.com\/bin\/view\/Transportation\/Passport\/EndUserInterface\/HighLevelDesigns\/UserAccessManagement
 **/
export class PassportAccessManagementCore extends CoralClient {
    constructor(config, handler) {
        const serdesHandler = new InterceptingHandler(handler, [
            passportAccessManagementCoreSerdesInterceptor,
        ]);
        super(config, serdesHandler);
    }
    /**
     * This Operation grants user permission to perform a operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/
    assignUser(request) {
        return super.call("AssignUser", request).pipe(map(() => undefined), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation grants batch user permission to perform a operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/
    batchAssignUser(request) {
        return super.call("BatchAssignUser", request).pipe(map(({ body }) => {
            if (!(body instanceof BatchAssignUserOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type BatchAssignUserOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation removes batch user permission to perform an operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/
    batchDeAssignUser(request) {
        return super.call("BatchDeAssignUser", request).pipe(map(({ body }) => {
            if (!(body instanceof BatchDeAssignUserOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type BatchDeAssignUserOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation creates a custom operation.
     * Sample custom operation: REVIEW
     **/
    createCustomOperation(request) {
        return super.call("CreateCustomOperation", request).pipe(map(() => undefined), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation creates a mapping between seller central enities such as rights and roles to Passport entities
     * such as permission key and permission.
     **/
    createPAMRoleMapping(request) {
        return super.call("CreatePAMRoleMapping", request).pipe(map(() => undefined), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation removes all the existing permissions of a user.
     * If the permission key does not have logisticsPartyId in it, permissions are removed
     * for all logisticsPartyIds for that user.
     **/
    deactivateUser(request) {
        return super.call("DeactivateUser", request).pipe(map(({ body }) => {
            if (!(body instanceof DeactivateUserOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type DeactivateUserOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation revokes user permission to perform a operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/
    deAssignUser(request) {
        return super.call("DeAssignUser", request).pipe(map(() => undefined), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation deletes the custom created operation.
     * Sample custom operation: REVIEW
     **/
    deleteCustomOperation(request) {
        return super.call("DeleteCustomOperation", request).pipe(map(() => undefined), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This is an operational api which will disable the LP to manage the permissions on the external terms. Internally
     * this operation unsubscribes the LP Id to the given term in SCAuth.
     **/
    disableExternalTermForLogisticParty(request) {
        return super.call("DisableExternalTermForLogisticParty", request).pipe(map(({ body }) => {
            if (!(body instanceof DisableExternalTermForLogisticPartyOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type DisableExternalTermForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This operation will enable an entity for a logistics party i.e. creates an active subscription for the entity
     * in ScAuth for the partnerId provided.
     **/
    enableExternalEntityForLogisticParty(request) {
        return super.call("EnableExternalEntityForLogisticParty", request).pipe(map(({ body }) => {
            if (!(body instanceof EnableExternalEntityForLogisticPartyOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type EnableExternalEntityForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This operation will enable the LP to manage the permissions on the external terms. Internally this operation subscribes the LP Id to the given term in SCAuth.
     **/
    enableExternalTermForLogisticParty(request) {
        return super.call("EnableExternalTermForLogisticParty", request).pipe(map(({ body }) => {
            if (!(body instanceof EnableExternalTermForLogisticPartyOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type EnableExternalTermForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This operation allows the LP to manage permissions for external terms. Internally, this operation subscribes
     * the LP Id to the specified term in SCAuth.It also subscribes LP to the default
     * subscription types if they are not already subscribed.
     **/
    enableSubscriptionForLogisticsParty(request) {
        return super.call("EnableSubscriptionForLogisticsParty", request).pipe(map(({ body }) => {
            if (!(body instanceof EnableSubscriptionForLogisticsPartyOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type EnableSubscriptionForLogisticsPartyOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation returns a list of audit events for a specific Logistics Provider with pagination
     **/
    getAuditEvents(request) {
        return super.call("GetAuditEvents", request).pipe(map(({ body }) => {
            if (!(body instanceof GetAuditEventsOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type GetAuditEventsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation returns the permissions that a user has on resources. The current ListAuthorizedOperations
     * allows us to return the permissions user has on a single resource. Modelling the output as an
     * entityPermissionsList allows us to send permissions of all the entities within the hierarchy.
     *
     * Note: Named this as GetAuthorizedPermissions instead of ListAuthorizedOperationsExternal with the intent of
     * migrating the functionality of existing API ListAuthorizedOperations into this API in the future.
     *
     * Input : SPPermissionKey {"logisticParty": "BNI"}, "user": { "userId": "user A", "userType": "EXTERNAL" },
     * Output : [
     * {
     * "entityPermissionsList": [
     * {
     * "entity": { "classType": "SPTermPermissionKey", "logisticParty": "BNI", "term": "SHIPPING_LABEL_SPECIFICATION" },
     * "permissionList": [ "VIEW", "EDIT" ]
     * },
     * {
     * "entity": { "classType": "SPTermPermissionKey", "logisticParty": "BNI", "term": "TRANSPORTATION_FORECAST" },
     * "permissionList": [ "VIEW" ]
     * }
     * ]
     * },...
     * ]
     **/
    getAuthorizedPermissions(request) {
        return super.call("GetAuthorizedPermissions", request).pipe(map(({ body }) => {
            if (!(body instanceof GetAuthorizedPermissionsOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type GetAuthorizedPermissionsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation retrieves the Permission Requests Details from the DDB table (PermissionRequestsTable)
     **/
    getPermissionRequests(request) {
        return super.call("GetPermissionRequests", request).pipe(map(({ body }) => {
            if (!(body instanceof GetPermissionRequestsOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type GetPermissionRequestsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation checks whether a user has permission to perform an operation on the permission key.
     * Internal usecase:
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     * External usecases:
     * 1) Sample operation : EDIT, Sample permission key: {Logistics Party (DHL), Term Labelling}, Sample User: {User : "user A", userType: "EXTERNAL"}
     * 2) Sample operation : EDIT, Sample permission key: {Logistics Party (DHL), Term Labelling}, rightsList: [labelling_view, labelling_edit]
     **/
    isUserAuthorized(request) {
        return super.call("IsUserAuthorized", request).pipe(map(({ body }) => {
            if (!(body instanceof IsUserAuthorizedOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type IsUserAuthorizedOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation queries all operations (including custom operations) created in PAM Core.
     * Sample operation: EDIT.
     **/
    listAllOperations() {
        return super.call("ListAllOperations").pipe(map(({ body }) => {
            if (!(body instanceof ListAllOperationsOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAllOperationsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Given an entity at a higher level on the hierarchy, this Operation returns the possible permissions that can
     * exist on resources within the lower level. For example, the terms which are enabled differ from logisticParty
     * to logisticParty. Given a logisticParty, this operation returns the possible permissions which can be
     * assigned to different terms.
     *
     * Input : SPPermissionKey {"logisticParty": "BNI"}
     * Output : [
     * {
     * "entityPermissionsList": [
     * {
     * "entity": { "classType": "SPTermPermissionKey", "logisticParty": "BNI", "term": "SHIPPING_LABEL_SPECIFICATION" },
     * "permissionList": [ "VIEW", "EDIT", "REVIEW", "ADMIN]
     * },
     * {
     * "entity": { "classType": "SPTermPermissionKey", "logisticParty": "BNI", "term": "TRANSPORTATION_FORECAST" },
     * "permissionList": [ "VIEW", "EDIT", "REVIEW", "ADMIN]
     * }
     * ]
     * },...
     * ]
     **/
    listAllPermissionsForEntity(request) {
        return super.call("ListAllPermissionsForEntity", request).pipe(map(({ body }) => {
            if (!(body instanceof ListAllPermissionsForEntityOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAllPermissionsForEntityOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation returns the groups that the user is member of in PAM resources.
     *
     * The need for this API is, when a user opens passport we need the groups info that the user is part of
     * to make corresponding calls to other services and load all the relevant CR's on dashboard. We cannot
     * user other existing PAM API's because when we open passport we do not have any information other than the
     * user accessing the passport.
     *
     * Input : {{User : "user A", userType: "PRINCIPAL"}, operation : "VIEW"}
     * Output : {"VIEW" : [{userId : "group A", userType: "POSIX"}]}
     * Description : 'user A' is member of 'group A' posix group.
     **/
    listAuthorizedGroups(request) {
        return super.call("ListAuthorizedGroups", request).pipe(map(({ body }) => {
            if (!(body instanceof ListAuthorizedGroupsOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAuthorizedGroupsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation queries all Operations that the user is authorized on a permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     *
     * @deprecated
     **/
    listAuthorizedOperations(request) {
        return super.call("ListAuthorizedOperations", request).pipe(map(({ body }) => {
            if (!(body instanceof ListAuthorizedOperationsOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAuthorizedOperationsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation queries all permission keys that the user is authorized to perform an operation on.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/
    listAuthorizedPermissionKeys(request) {
        return super.call("ListAuthorizedPermissionKeys", request).pipe(map(({ body }) => {
            if (!(body instanceof ListAuthorizedPermissionKeysOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAuthorizedPermissionKeysOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation queries all the users who have permission to perform an operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/
    listAuthorizedUsers(request) {
        return super.call("ListAuthorizedUsers", request).pipe(map(({ body }) => {
            if (!(body instanceof ListAuthorizedUsersOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAuthorizedUsersOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Provides a list of the external entities (Terms\/Categories etc) which are enabled for managing
     * permissions for the given logisticPartyId and permission Key.
     **/
    listEnabledExternalEntitiesForLogisticParty(request) {
        return super
            .call("ListEnabledExternalEntitiesForLogisticParty", request)
            .pipe(map(({ body }) => {
            if (!(body instanceof ListEnabledExternalEntitiesForLogisticPartyOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListEnabledExternalEntitiesForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * Lists the external terms which are enabled for managing permissions of the LP Id.
     **/
    listEnabledExternalTermsForLogisticParty(request) {
        return super.call("ListEnabledExternalTermsForLogisticParty", request).pipe(map(({ body }) => {
            if (!(body instanceof ListEnabledExternalTermsForLogisticPartyOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListEnabledExternalTermsForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation stores the Permission Requests from a User in the DDB table (PermissionRequestsTable)
     **/
    putPermissionRequests(request) {
        return super.call("PutPermissionRequests", request).pipe(map(({ body }) => {
            if (!(body instanceof PutPermissionRequestsOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type PutPermissionRequestsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * This Operation updates the status of a Permission Request in the DDB table (PermissionRequestsTable)
     **/
    updatePermissionRequest(request) {
        return super.call("UpdatePermissionRequest", request).pipe(map(({ body }) => {
            if (!(body instanceof UpdatePermissionRequestOutput)) {
                throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type UpdatePermissionRequestOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
}
PassportAccessManagementCore.assembly = "com.amazon.passportaccessmanagementcore";
PassportAccessManagementCore.serviceName = "PassportAccessManagementCore";
